import { sentenceCase } from "change-case";
import { OrderOfferStatus } from "codegen";
import { CSSProperties } from "react";
import styled, { RuleSet } from "styled-components";

import { blueStyle, defaultStyle, errorStyle, Filter, greenStyle, yellowStyle } from "pages/Strombestilling/components/Filter";
import { FilterTableRoot, FilterTableWrapper } from "pages/Strombestilling/components/OrderFilterTable";
import { ChannelMap, OfferStatusMap } from "pages/Strombestilling/orderoffers/OrderOffersPage";

export function OfferFilterTable({
	name,
	data,
	selected,
	setSelected,
	style,
	toSentenceCase = true,
}: {
	readonly name: string;
	readonly data: Record<string, number | undefined>;
	readonly selected: string | null;
	readonly setSelected: (newValue?: string) => void;
	readonly style?: CSSProperties;
	readonly toSentenceCase?: boolean;
}) {
	const isStatus = name === "Status";
	const total = Object.entries(data)
		.map(([_, v]) => v)
		.reduce((value, current) => {
			return (current ?? 0) + (value ?? 0);
		}, 0);
	const displayStatus = isStatus || name === "Kanal";
	const totalString = displayStatus ? ` (Totalt: ${total})` : "";
	const changeCase = (x: string) => (toSentenceCase ? sentenceCase(x) : x);

	return (
		<FilterTableWrapper style={style}>
			<FilterTableRoot>
				<thead>
					<tr>
						<th colSpan={2}>{name + totalString}</th>
					</tr>
				</thead>
				<tbody>
					{Object.entries(data).map(([k, v]) => {
						return (
							<tr key={k}>
								<td>
									<OfferFilter
										$status={isStatus ? (k as OrderOfferStatus) : undefined}
										onClick={() => setSelected?.(selected === k ? undefined : k)}
									>
										{isStatus
											? (OfferStatusMap.get(k as OrderOfferStatus) ?? "Ukjent status")
											: name === "Kanal"
												? ChannelMap.get(k)
												: changeCase(k)}
									</OfferFilter>
								</td>
								<td className="number">{v}</td>
							</tr>
						);
					})}
				</tbody>
			</FilterTableRoot>
		</FilterTableWrapper>
	);
}

export const OfferFilter = styled(Filter)<{ $status?: OrderOfferStatus }>`
	${({ $status }) => colorMap.get($status) ?? defaultStyle};
	&:hover {
		opacity: ${(props) => (props.onClick ? 0.7 : 1)};
	}
`;

const colorMap: Map<OrderOfferStatus | undefined, RuleSet<object>> = new Map([
	// grønn
	[OrderOfferStatus.Ordered, greenStyle],
	// blå
	[OrderOfferStatus.Created, blueStyle],
	[OrderOfferStatus.Opened, blueStyle],
	[OrderOfferStatus.PendingConsent, blueStyle],
	// rød
	[OrderOfferStatus.Expired, errorStyle],
	[OrderOfferStatus.ConsentExpired, errorStyle],
	[OrderOfferStatus.ConsentRejected, errorStyle],
	[OrderOfferStatus.ConsentError, errorStyle],
	// gul
	[OrderOfferStatus.CreditCheckBlocked, yellowStyle],
	[OrderOfferStatus.CreditCheckFailed, yellowStyle],
	// default
	[undefined, defaultStyle],
]);
